export const DOCUMENT_TYPE_ID = "documentTypeId";
export const DOCUMENT_TYPE = "documentType";
export const TRANSACTIONAL_PROCESSOR = "transactionalProcessor";
export const START_RANGE = "startRange";
export const END_RANGE = "endRange";
export const NUMBER_RANGES = "numberRanges";
export const ACTIVE = "active";
export const UPDATED_AT = "updatedAt";
export const UPDATED_BY = "updatedBy";
export const DESCRIPTION = "description";
export const COMMUNITY_ID = "communityId";

export const START_NUMBER = "startNumber";
export const END_NUMBER = "endNumber";
export const RANGE_DESCRIPTION = "description";
export const ACTIVATE_IMMEDIATELY = "activateImmediately";
export const WARNING_PERCENTAGE = "warningThresholdPercent";
